module.exports = __webpack_public_path__ + "static/img/TMBcharacterPhotos_0000_salim.9359612.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/TMBcharacterPhotos_0000_salim.jpg
// module id = 4GV7
// module chunks = 1